module.exports = __webpack_public_path__ + "img/pablo.acca2a0a.jpg";